import { Component, OnInit } from "@angular/core";

@Component({
    selector: 'G10-map-with-left-panel-layout',
    templateUrl: './map-with-left-panel.layout.html',
    styleUrls: ['./map-with-left-panel.layout.css']
})

export class MapWithLeftPanelLayout implements OnInit{
    constructor(){}
    ngOnInit(): void {
        
    }
}